module.exports = __webpack_public_path__ + "static/media/local.2f44ff57.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/local.jpg
 ** module id = 149
 ** module chunks = 0
 **/